import React, { useState, useEffect } from 'react'
import Typography from 'aldoo-ra/Typography'
import Button from 'aldoo-ra/Button'
import Modal from 'aldoo-ra/Modal'
import Checkbox from 'aldoo-ra/Checkbox'

const ExportOptionsDialog = ({ isOpen, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false)
  const [selectedFields, setSelectedFields] = useState({
    email: true,
    name: true,
    language: true,
    registered: true,
    subscribed: true,
    subscribedAt: true,
    unsubscribeReason: true
  })

  useEffect(() => {
    if (isOpen) {
      setSelectedFields({
        email: true,
        name: true,
        language: true,
        registered: true,
        subscribed: true,
        subscribedAt: true,
        unsubscribeReason: true
      })
    }
  }, [isOpen])

  const fieldLabels = {
    email: 'Email Address',
    name: 'Name',
    language: 'Language',
    registered: 'Registration Status',
    subscribed: 'Subscription Status',
    subscribedAt: 'Subscribed Date',
    unsubscribeReason: 'Unsubscribe Reason'
  }

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await onConfirm(selectedFields)
      onClose()
    } catch (error) {
      // Error handling in parent
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    if (!loading) {
      onClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      variant="admin_compact"
      className="max-w-md"
    >
      <div className="p-6">
        <Typography component="h1" variant="admin_h3" className="mb-4">
          Export Options
        </Typography>

        <Typography variant="admin_txt1_dim">
          Select which fields to include in the exported CSV file:
        </Typography>

        <div className="space-y-4 mt-4">
          {Object.entries(fieldLabels).map(([field, label]) => {
            const isRequired = field === 'email'
            const isDisabled = isRequired || loading
            const displayLabel = isRequired ? `${label} (Required)` : label

            return (
              <div key={field} className="flex items-center rounded-lg hover:bg-admin_canvas space-x-3 p-2 transition-colors">
                <Checkbox
                  variant="admin"
                  isOn={selectedFields[field]}
                  onChange={(newValue) => {
                    if (!isDisabled) {
                      setSelectedFields(prev => ({
                        ...prev,
                        [field]: newValue
                      }))
                    }
                  }}
                  disabled={isDisabled}
                />
                <Typography
                  variant="admin_txt1"
                  className={`cursor-pointer select-none flex-1 ${
                    isRequired
                      ? 'text-admin_text font-semibold'
                      : 'text-admin_text hover:text-admin_primary'
                  }`}
                  onClick={() => {
                    if (!isDisabled) {
                      setSelectedFields(prev => ({
                        ...prev,
                        [field]: !prev[field]
                      }))
                    }
                  }}
                >
                  {displayLabel}
                </Typography>
              </div>
            )
          })}
        </div>

        <div className="flex items-center justify-end border-t border-admin_bordered space-x-3 mt-6 pt-4">
          <Button variant="admin_secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="admin_primary" onClick={handleConfirm} loading={loading}>
            Export CSV
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ExportOptionsDialog
